<ion-header>
  <app-page-header
    [hideBorder]="true"
    pageTitle="Correctional Facility"
  ></app-page-header>
</ion-header>
<ion-content>
  <app-page-template>
    <section id="page-title">
      <p>Please search for your loved one's facility by name, city, or zip/postal code.</p>
      <ion-searchbar
        #searchbar
        class="text-left"
        placeholder="City, Zip Code, or Facility Name"
        [autofocus]="true"
        [debounce]="1000"
        (ionChange)="populateFacilities($event)"
        (ionClear)="clearSearch()"
      ></ion-searchbar>
    </section>
    <section id="page-content">
      <div class="text-center text-secondary font-italic">
        <p *ngIf="!facilityResults.length && filter?.length < 3" class="mt-4">Type at least 3 characters to search</p>
      </div>
      <app-facility-results
        *ngIf="searching || searchAttempted"
        [facilities]="facilityResults"
        [searching]="searching"
        [searchAttempted]="searchAttempted"
        (facilitySelected)="selectFacility($event)"
      ></app-facility-results>
    </section>
    <app-cta-buttons
      [secondaryCtaLabel]="searchAttempted ? 'Can\'t find your facility? Contact Support' : ''"
      secondaryCtaId="secondary-cta"
      (secondaryCtaClick)="openSupportLink()"
    ></app-cta-buttons>
  </app-page-template>
</ion-content>
